package com.starparty.app.geometry

class SP_Point constructor(var x: Double = 0.0, var y: Double = 0.0) {

    fun setLocation(x: Double, y: Double) {
        this.x = x
        this.y = y
    }

}